// generated by genversion
module.exports = '3.73.0';



//////////////////
// WEBPACK FOOTER
// ./src/utils/version.js
// module id = 1501
// module chunks = 0